import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const UploadsListHeader = ({ profile }) => {
  const intl = useIntl();

  return (
    <tr>
      <th className="upload-thumbnail">
        {' '}
      </th>
      {profile.is_admin && (
        <th className="upload-user-name">
          {intl.formatMessage({ defaultMessage: 'User' })}
        </th>
      )}
      <th className="upload-date">
        {intl.formatMessage({ defaultMessage: 'Created' })}
      </th>
      <th className="upload-files">
        {intl.formatMessage({ defaultMessage: 'Files' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

UploadsListHeader.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default UploadsListHeader;
